import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Divider,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  IconButton,
  Tooltip,
  TextField,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  Snackbar,
  Alert,
  Collapse,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import SyncIcon from "@mui/icons-material/Sync";
import DevicesIcon from "@mui/icons-material/Devices";
import axios from "../../utils/axiosInstance";
import AddRecipient from "./AddRecipient";
import DeleteRecipient from "./DeleteRecipient";
import { formatDate } from "../../utils/formatDate";
import ConfirmDialog from "../ConfirmDialog";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";
export default function NotificationGroupDetailed({ groupId, onBack }) {
  const theme = useTheme();
  const [groupDetails, setGroupDetails] = useState(null);
  const [devices, setDevices] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [unitsSearchQuery, setUnitsSearchQuery] = useState("");
  const [filteredDevices, setFilteredDevices] = useState([]);

  const [showAddRecipients, setShowAddRecipients] = useState(false);

  const [showDeleteRecipients, setShowDeleteRecipients] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [removeLoading, setRemoveLoading] = useState(false);

  // Notification states
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Loading states for individual checkbox updates
  const [updatingUsers, setUpdatingUsers] = useState(new Set());

  // Group form states
  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [parentGroup, setParentGroup] = useState("");
  const [region, setRegion] = useState("");

  const [expandedRows, setExpandedRows] = useState({});

  const truncateText = (text, maxLength = 45) => {
    if (!text) return "";
    return text.length > maxLength
      ? "..." + text.substring(text.length - maxLength)
      : text;
  };

  useEffect(() => {
    if (groupId) {
      fetchGroupDetails();
    }
  }, [groupId]);

  useEffect(() => {
    // Filter users based on search query
    const filtered = members.filter(
      (member) =>
        (member.user.name || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (member.user.email || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (member.user.phone || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()),
    );
    setFilteredUsers(filtered);
    // console.log("**************", filtered)
  }, [members, searchQuery]);

  useEffect(() => {
    // Filter devices based on search query
    const filtered = devices.filter(
      (device) =>
        (device.name || "")
          .toLowerCase()
          .includes(unitsSearchQuery.toLowerCase()) ||
        (device.id || "")
          .toLowerCase()
          .includes(unitsSearchQuery.toLowerCase()),
    );
    setFilteredDevices(filtered);
  }, [devices, unitsSearchQuery]);

  useEffect(() => {
    if (groupDetails) {
      setGroupName(groupDetails.name || "");
      setGroupDescription(groupDetails.description || "");
      setParentGroup(groupDetails.group?.name || "");
      setRegion(groupDetails.region?.name || "");
    }
  }, [groupDetails]);

  const fetchGroupDetails = async () => {
    try {
      setLoading(true);
      // Fetch group details
      const Response = await axios.get(
        `${process.env.REACT_APP_API_GATEAWAY}/notificationGroups/${groupId}/details`,
      );
      setGroupDetails(Response.data);

      // Fetch devices associated with the group
      try {
        setDevices(Response.data.devices || []);
        console.log(
          "devicesResponse.data.users",
          Response.data.devices,
          "devicesResponse.data.users",
        );
      } catch (error) {
        console.warn("Devices endpoint not available:", error);
      }

      // Fetch users associated with the group
      try {
        setMembers(Response.data.members || []);
      } catch (error) {
        console.warn("Users endpoint not available:", error);
        // Mock data for demonstration
      }
    } catch (error) {
      console.error("Error fetching group details:", error);
      showNotification("Error fetching group details", "error");
    } finally {
      setLoading(false);
    }
  };

  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  const toggleRowExpansion = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // const updateUserNotificationSettings = async (userId, field, value) => {
  //   // Add user to updating set
  //   setUpdatingUsers((prev) => new Set([...prev, `${userId}-${field}`]));
  //   try {
  //     const payload = {
  //       userId: userId,
  //       notificationGroupId: groupId,
  //       [field]: value,
  //     };

  //     await axios.put(
  //       `${process.env.REACT_APP_API_GATEAWAY}/recipients/updateByUserAndGroup`,
  //       payload
  //     );

  //     // Update the local state
  //     setMembers((prevUsers) =>
  //       prevUsers.map((user) =>
  //         user.id === userId ? { ...user, [field]: value } : user
  //       )
  //     );

  //     showNotification(
  //       `${field === "smsEnable" ? "SMS" : "Email"} notification ${value ? "enabled" : "disabled"
  //       } successfully`,
  //       "success"
  //     );
  //   } catch (error) {
  //     console.error(`Error updating ${field} for user ${userId}:`, error);
  //     showNotification(
  //       `Error updating ${field === "smsEnable" ? "SMS" : "email"
  //       } notification`,
  //       "error"
  //     );
  //   } finally {
  //     // Remove user from updating set
  //     setUpdatingUsers((prev) => {
  //       const newSet = new Set(prev);
  //       newSet.delete(`${userId}-${field}`);
  //       return newSet;
  //     });
  //   }
  // };
  const updateUserNotificationSettings = async (memberId, field, value) => {
    // Add user to updating set
    setUpdatingUsers((prev) => new Set([...prev, `${memberId}-${field}`]));
    try {
      const payload = {
        // userId: userId,
        // notificationGroupId: groupId,
        [field]: value,
        UI_Description: `${getUIDescription()}\n update user notification settings`,
      };

      await axios.put(
        `${process.env.REACT_APP_API_GATEAWAY}/members/${memberId}`,
        payload,
      );

      // Update the local state
      setMembers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === memberId ? { ...user, [field]: value } : user,
        ),
      );

      showNotification(
        `${field === "smsEnable" ? "SMS" : "Email"} notification ${
          value ? "enabled" : "disabled"
        } successfully`,
        "success",
      );
    } catch (error) {
      console.error(`Error updating ${field} for user ${memberId}:`, error);
      showNotification(
        `Error updating ${
          field === "smsEnable" ? "SMS" : "email"
        } notification`,
        "error",
      );
    } finally {
      // Remove user from updating set
      setUpdatingUsers((prev) => {
        const newSet = new Set(prev);
        newSet.delete(`${memberId}-${field}`);
        return newSet;
      });
    }
  };

  const handleSmsToggle = (userId, currentValue) => {
    updateUserNotificationSettings(userId, "smsEnable", !currentValue);
  };

  const handleEmailToggle = (userId, currentValue) => {
    updateUserNotificationSettings(userId, "emailEnable", !currentValue);
  };

  const handleUserSelect = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId],
    );
  };

  const handleSelectAll = () => {
    if (selectedUsers.length === filteredUsers.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(filteredUsers.map((user) => user.id));
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <CircularProgress color="#60a5fa" size={60} />
      </Box>
    );
  }
  const handleDeleteClick = (deviceId) => {
    setSelectedDevice(deviceId);
    setConfirmOpen(true);
  };

  const handleRemoveDevice = async () => {
    try {
      const deviceId = selectedDevice;
      setRemoveLoading(true);
      await axios.delete(
        `${process.env.REACT_APP_API_GATEAWAY}/assets/hard?deviceId=${deviceId}&groupId=${groupId}`,
        {data:{
          UI_Description: `${getUIDescription()}\n remove device`,
        }}
      );

      // Update local state
      setDevices((prevDevices) =>
        prevDevices.filter((device) => device.id !== deviceId),
      );
      setRemoveLoading(false);
      setConfirmOpen(false);
      showNotification("Device removed from group successfully", "success");
    } catch (error) {
      console.error("Error removing device:", error);
      showNotification("Error removing device from group", "error");
      setRemoveLoading(false);
      setConfirmOpen(false);
    }
  };
  return (
    <Box sx={{ p: 2, height: "100%" }}>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Tooltip title="Back">
          <IconButton onClick={onBack} sx={{ mr: 1 }}>
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
        <Typography variant="h6" fontWeight="bold">
          Notification Group Details
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          height: { xs: "auto", sm: "76vh" },
          gap: 2,
        }}
      >
        {/* Left Panel - Recipients */}
        <Box
          sx={{
            width: { xs: "100%", sm: "60%" },
            display: "flex",
            flexDirection: "column",
            minHeight: { xs: "50vh", sm: "auto" },
            order: { xs: 1, sm: 0 },
          }}
        >
          <Paper
            sx={{
              p: 2,
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Recipients Header */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                Recipients
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Tooltip title="Back">
                  <IconButton size="small" onClick={onBack}>
                    <ArrowBackIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Add recipients">
                  <IconButton
                    size="small"
                    onClick={() => setShowAddRecipients(true)}
                  >
                    <PersonAddIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Remove Recipients">
                  <IconButton
                    size="small"
                    onClick={() => setShowDeleteRecipients(true)}
                  >
                    <PersonRemoveIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            {/* Search */}
            <TextField
              placeholder="Search By Name ..."
              variant="outlined"
              size="small"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ mb: 2 }}
            />

            {/* Recipients Table */}
            <TableContainer
              sx={{
                overflowY: "auto",
                height: { xs: "40vh", sm: "63vh" },
              }}
            >
              <Table
                stickyHeader
                size="small"
                sx={{
                  tableLayout: "fixed",
                  width: "100%", // Table takes full container width
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: theme.palette.grey[100],
                      // transform: {
                      //   xs: "scale(0.90)", // phones
                      //   sm: "scale(0.97)", // small tablets
                      //   md: "scale(1)", // medium+
                      // },
                    }}
                  >
                    {/* Mobile expand button column */}
                    <TableCell
                      sx={{
                        display: { xs: "table-cell",  sm: "table-cell", md: "none" },
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "12px",
                        padding: "12px 8px",
                        width: "50px",
                      }}
                    >
                      Details
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                          md: "0.875rem",
                        },
                        padding: { xs: "6px", sm: "8px", md: "16px" },
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                          md: "0.875rem",
                        },
                        padding: { xs: "6px", sm: "8px", md: "16px" },
                      }}
                    >
                      Phone
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        display: { xs: "none", sm: "none", md: "table-cell" },
                        fontWeight: "bold",
                        width: "29%",
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                          md: "0.875rem",
                        },
                        padding: { xs: "6px", sm: "8px", md: "16px" },
                      }}
                    >
                      Email Address
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        display: { xs: "none",sm:"none", md: "table-cell" },
                        fontWeight: "bold",
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                          md: "0.875rem",
                        },
                        padding: { xs: "6px", sm: "8px", md: "16px" },
                      }}
                    >
                      Registration Date
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: { xs: "13%", sm: "10%", md: "9%" },
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                          md: "0.875rem",
                        },
                        padding: { xs: "4px", sm: "6px", md: "16px" },
                        textAlign: "center",
                      }}
                    >
                      Text
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        width: { xs: "13%", sm: "10%", md: "9%" },
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                          md: "0.875rem",
                        },
                        padding: { xs: "4px", sm: "6px", md: "16px" },
                        textAlign: "center",
                      }}
                    >
                      Email
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredUsers.map((member, index) => (
                    <React.Fragment key={member.id}>
                      <TableRow
                        key={member.id}
                        hover
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "#2f3136" : "#3a3c43",
                          "&:hover": {
                            backgroundColor: "#4a4d54",
                          },
                          "& td": {
                            fontSize: {
                              xs: "0.7rem",
                              sm: "0.7rem",
                              md: "0.7rem",
                            },
                            padding: { xs: "6px", sm: "8px", md: "16px" },
                            wordBreak: "break-word",
                            overflow: "hidden",
                          },
                        }}
                      >
                        {/* Expand Button - Mobile Only */}
                        <TableCell
                          sx={{
                            display: { xs: "table-cell",sm:"table-cell", md: "none" },
                            textAlign: "center",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => toggleRowExpansion(member.id)}
                            sx={{ color: "white" }}
                          >
                            {expandedRows[member.id] ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell
                          sx={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: 0, // Forces text truncation
                          }}
                        >
                          <span title={member.user.name}>
                            {member.user.name}
                          </span>
                        </TableCell>
                        <TableCell
                          sx={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: 0, // Forces text truncation
                          }}
                        >
                          <span title={member.user.phone}>
                            {member.user.phone}
                          </span>
                        </TableCell>
                        <TableCell
                          sx={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: 0, // Forces text truncation
                            display: { xs: "none", sm: "none", md: "table-cell" },
                            textAlign: "center",
                            fontSize: { xs: "11px", sm: "14px", md: "15px" },
                          }}
                        >
                          <span title={member.user.email}>
                            {member.user.email}
                          </span>
                        </TableCell>
                        <TableCell
                          sx={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: 0, // Forces text truncation
                            display: { xs: "none", sm:"none", md: "table-cell" },
                            textAlign: "center",
                            fontSize: { xs: "11px", sm: "14px", md: "15px" },
                          }}
                        >
                          <span
                            title={new Date(member.date).toLocaleDateString()}
                          >
                            {new Date(member.date).toLocaleDateString()}
                          </span>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            padding: { xs: "4px", sm: "6px", md: "16px" },
                            position: "relative",
                          }}
                        >
                          <Box
                            sx={{
                              position: "relative",
                              display: "inline-flex",
                            }}
                          >
                            <Checkbox
                              checked={member.smsEnable}
                              onChange={() =>
                                handleSmsToggle(member.id, member.smsEnable)
                              }
                              disabled={updatingUsers.has(
                                `${member.id}-smsEnable`,
                              )}
                              size={
                                window.innerWidth < 600 ? "small" : "medium"
                              }
                              sx={{
                                transform: {
                                  xs: "scale(0.8)",
                                  sm: "scale(0.9)",
                                  md: "scale(1)",
                                },
                              }}
                            />
                            {updatingUsers.has(`${member.id}-smsEnable`) && (
                              <CircularProgress
                                size={16}
                                sx={{
                                  color: "#60a5fa",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  marginTop: "-8px",
                                  marginLeft: "-8px",
                                }}
                              />
                            )}
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            padding: { xs: "4px", sm: "6px", md: "16px" },
                            position: "relative",
                          }}
                        >
                          <Box
                            sx={{
                              position: "relative",
                              display: "inline-flex",
                            }}
                          >
                            <Checkbox
                              checked={member.emailEnable}
                              onChange={() =>
                                handleEmailToggle(member.id, member.emailEnable)
                              }
                              disabled={updatingUsers.has(
                                `${member.id}-emailEnable`,
                              )}
                              size={
                                window.innerWidth < 600 ? "small" : "medium"
                              }
                              sx={{
                                transform: {
                                  xs: "scale(0.8)",
                                  sm: "scale(0.9)",
                                  md: "scale(1)",
                                },
                              }}
                            />
                            {updatingUsers.has(`${member.id}-emailEnable`) && (
                              <CircularProgress
                                size={16}
                                sx={{
                                  color: "#60a5fa",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  marginTop: "-8px",
                                  marginLeft: "-8px",
                                }}
                              />
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                      {/* Mobile Collapsed Row */}
                      <TableRow
                        sx={{ display: { xs: "table-row", sm:"table-row", md: "none" } }}
                      >
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={5}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#2f3136" : "#3a3c43",
                          }}
                        >
                          <Collapse
                            in={expandedRows[member.id]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box sx={{ py: 2, px: 1 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1.5,
                                }}
                              >
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: "#999", fontWeight: "bold" }}
                                  >
                                    Email Address:
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "white" }}
                                  >
                                    {member.user.email}
                                  </Typography>
                                </Box>

                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: "#999", fontWeight: "bold" }}
                                  >
                                    Registration Date:
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "white" }}
                                  >
                                    {new Date(member.date).toLocaleDateString()}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>

        {/* Right Panel */}
        <Box
          sx={{
            width: { xs: "100%", sm: "40%" },
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            order: { xs: 0, sm: 0 },
          }}
        >
          {/* Top Right - Notification Group Information */}
          <Paper
            sx={{
              p: 3,
              pb: 1,
              height: { xs: "auto", sm: "35%" },
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "grid",
                // gridTemplateColumns: "1fr 1fr",
                // gap: 4,
                height: "100%",
                overflow: "auto",
              }}
            >
              {/* Left Column - Notification Group Information */}
              <Box
                sx={{
                  // borderRight: 1,
                  borderColor: "divider",
                  pr: 3,
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{
                    mb: 3,
                    pb: 1,
                    borderBottom: 1,
                    borderColor: "primary.light",
                    fontSize: { xs: "0.7rem", sm: "0.9rem", md: "1rem" },
                    lineHeight: 1.2,
                  }}
                >
                  Notification Group Information
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    height: "calc(100% - 60px)",
                    overflow: "hidden",
                  }}
                >
                  <Box>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      color="text.secondary"
                      sx={{
                        mb: 0.5,
                        textTransform: "uppercase",
                        fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem" },
                      }}
                    >
                      Name
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: {
                          xs: "0.65rem",
                          sm: "0.9rem",
                          md: "0.95rem",
                        },
                      }}
                    >
                      {groupDetails?.name || "No name"}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      color="text.secondary"
                      sx={{
                        mb: 0.5,
                        textTransform: "uppercase",
                        fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem" },
                      }}
                    >
                      Description
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: {
                          xs: "0.65rem",
                          sm: "0.9rem",
                          md: "0.95rem",
                        },
                        lineHeight: 1.4,
                      }}
                    >
                      {groupDetails?.description || "No description"}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      color="text.secondary"
                      sx={{
                        mb: 0.5,
                        textTransform: "uppercase",
                        fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.75rem" },
                      }}
                    >
                      Date Created
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: {
                          xs: "0.65rem",
                          sm: "0.9rem",
                          md: "0.95rem",
                        },
                        marginBottom: 1,
                      }}
                    >
                      {formatDate(groupDetails?.date) || "No date"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Right Column - Parent Group */}
              {/* <Box sx={{ pl: 1 }}>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{
                    mb: 3,
                    pb: 1,
                    borderBottom: 1,
                    borderColor: "primary.light",
                    fontSize: "1rem",
                    lineHeight: 1.2,
                  }}
                >
                  Parent Group
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    height: "calc(100% - 60px)",
                    overflow: "hidden",
                  }}
                >
                  <Box>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      color="text.secondary"
                      sx={{
                        mb: 0.5,
                        textTransform: "uppercase",
                        fontSize: "0.75rem",
                      }}
                    >
                      Parent Group
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                      }}
                    >
                      {groupDetails?.group?.name || "No parent group"}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      color="text.secondary"
                      sx={{
                        mb: 0.5,
                        textTransform: "uppercase",
                        fontSize: "0.75rem",
                      }}
                    >
                      Region
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                      }}
                    >
                      {groupDetails?.region?.name || "No region"}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      color="text.secondary"
                      sx={{
                        mb: 0.5,
                        textTransform: "uppercase",
                        fontSize: "0.75rem",
                      }}
                    >
                      Route
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                      }}
                    >
                      {groupDetails?.route?.name || "No route"}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      variant="subtitle2"
                      fontWeight="600"
                      color="text.secondary"
                      sx={{
                        mb: 0.5,
                        textTransform: "uppercase",
                        fontSize: "0.75rem",
                      }}
                    >
                      # of Units
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.primary",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                      }}
                    >
                      {devices?.length || 10}
                    </Typography>
                  </Box>
                </Box>
              </Box> */}
            </Box>
          </Paper>
          {/* end of Top Right - Notification Group Information */}

          {/* Bottom Right - Units assigned to this Group */}
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: { xs: "auto", sm: "65%" },
              minHeight: { xs: "40vh", sm: "auto" },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1, sm: 0 },
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                Units assigned to this Group
              </Typography>

              {/* Units Search */}
              <TextField
                placeholder="Search:"
                variant="outlined"
                size="small"
                value={unitsSearchQuery}
                onChange={(e) => setUnitsSearchQuery(e.target.value)}
                sx={{ mb: 1, width: { xs: "100%", sm: 300 } }}
              />
            </Box>

            {/* Units Table */}
            <TableContainer
              sx={{
                overflowY: "auto",
                height: { xs: "35vh", sm: "40vh" },
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: theme.palette.grey[100] }}>
                    <TableCell
                      sx={{
                        display: { xs: "table-cell",sm:"table-cell", md: "none" },
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "12px",
                        padding: "12px 8px",
                        width: "50px",
                      }}
                    >
                      Details
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        display: { xs: "none",sm:"none", md: "table-cell" },
                      }}
                    >
                      #
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                        display: { xs: "none",sm:"none", md: "table-cell" },
                      }}
                    >
                      Unit Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Modem Serial Number
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredDevices.map((device, index) => (
                    <React.Fragment key={device.id}>
                      <TableRow
                        key={device.id}
                        hover
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "#2f3136" : "#3a3c43",
                          "&:hover": {
                            backgroundColor: "#4a4d54",
                          },
                        }}
                      >
                        {/* Expand Button - Mobile Only */}
                        <TableCell
                          sx={{
                            display: { xs: "table-cell",sm:"table-cell", md: "none" },
                            textAlign: "center",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => toggleRowExpansion(device.id)}
                            sx={{ color: "white" }}
                          >
                            {expandedRows[device.id] ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell
                          sx={{
                            display: { xs: "none",sm:"none", md: "table-cell" },
                            fontSize: { xs: "11px", sm: "14px", md: "15px" },
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          sx={{
                            display: { xs: "none",sm:"none", md: "table-cell" },
                            fontSize: { xs: "11px", sm: "14px", md: "15px" },
                          }}
                        >
                          {truncateText(device.name)}
                        </TableCell>
                        <TableCell>{truncateText(device.id)}</TableCell>
                        <TableCell>
                          {/* Simple Remove Button */}
                          <Button
                            variant="contained"
                            size="small"
                            color="error"
                            sx={{
                              fontSize: "0.75rem",
                              padding: "4px 8px",
                              minWidth: "auto",
                            }}
                            onClick={() => handleDeleteClick(device.id)}
                          >
                            Remove
                          </Button>
                        </TableCell>
                      </TableRow>
                      {/* Mobile Collapsed Row */}
                      <TableRow
                        sx={{ display: { xs: "table-row",sm:"table-row", md: "none" } }}
                      >
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={3}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#2f3136" : "#3a3c43",
                          }}
                        >
                          <Collapse
                            in={expandedRows[device.id]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box sx={{ py: 2, px: 1 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 1.5,
                                }}
                              >
                                {/* Row 1 */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#999",
                                      fontWeight: "bold",
                                      minWidth: 70,
                                    }}
                                  >
                                    #:
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "white" }}
                                  >
                                    {index + 1}
                                  </Typography>
                                </Box>

                                {/* Row 2 */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "#999",
                                      fontWeight: "bold",
                                      minWidth: 70,
                                    }}
                                  >
                                    Unit Name:
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "white" }}
                                  >
                                    {truncateText(device.name)}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      <AddRecipient
        open={showAddRecipients}
        onClose={() => setShowAddRecipients(false)}
        groupId={groupId}
        onRecipientsUpdated={fetchGroupDetails}
        filteredUsers={filteredUsers}
      />
      <DeleteRecipient
        open={showDeleteRecipients}
        onClose={() => setShowDeleteRecipients(false)}
        groupId={groupId}
        onRecipientsUpdated={fetchGroupDetails}
        filteredUsers={filteredUsers}
      />

      <ConfirmDialog
        open={confirmOpen}
        loading={removeLoading}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleRemoveDevice}
        title="Remove Device "
        body={`Are you sure you want to remove device "${selectedDevice}" from ${groupDetails?.name}?`}
        confirmText="Remove"
      />
    </Box>
  );
}
